import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ORGANIZATION_BUILDER_ROUTE } from '../shared/constants/routes';
import { OrganizationBuilderComponent } from './organization-builder/organization-builder.component';

const routes: Routes = [
  {
    path: ORGANIZATION_BUILDER_ROUTE,
    component: OrganizationBuilderComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganizationBuilderRoutingModule {}
